var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c("div", { staticClass: "section" }, [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("SeaExport.BackUpWarehouse")))
      ]),
      _c(
        "div",
        { staticClass: "warehouse-wrap" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.LoadingCharge2") }
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "packingChargeAmount",
                      disabled: !_vm.chargeEnable,
                      precision: 2,
                      min: 0,
                      max: 999999999999,
                      "controls-position": "right"
                    },
                    on: { change: _vm.dealPackingCharge },
                    model: {
                      value: _vm.packingChargeAmount,
                      callback: function($$v) {
                        _vm.packingChargeAmount = $$v
                      },
                      expression: "packingChargeAmount"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.localCurrency))]),
                  _vm.isZh
                    ? [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.RmbNumberOfDamagedAndDamp")
                            )
                          )
                        ]),
                        _c("el-input-number", {
                          attrs: {
                            no: "quantity",
                            value:
                              _vm.backUpWarehouseInfo.quantity === 0
                                ? undefined
                                : _vm.backUpWarehouseInfo.quantity,
                            precision: 0,
                            min: 0,
                            max: 999999999999,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(val) {
                              _vm.backUpWarehouseInfo.quantity = val
                            }
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
              !_vm.isZh
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.RmbNumberOfDamagedAndDamp2")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "quantity",
                          value:
                            _vm.backUpWarehouseInfo.quantity === 0
                              ? undefined
                              : _vm.backUpWarehouseInfo.quantity,
                          precision: 0,
                          min: 0,
                          max: 999999999999,
                          "controls-position": "right"
                        },
                        on: {
                          input: function(val) {
                            _vm.backUpWarehouseInfo.quantity = val
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { label: _vm.warehouseCmpLabel }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "warehouseCmp",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      cache: false,
                      "static-options": _vm.backUpWarehouseCompanyList,
                      "default-value":
                        _vm.backUpWarehouseInfo.warehouseCmp || "",
                      filterable: ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.backUpWarehouseInfo.warehouseCmp = p.value || 0
                        _vm.warehouseChangeHandler(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.openWarehouse
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.WareHouseName") }
                    },
                    [
                      _vm.openWarehouse
                        ? _c(
                            "el-select",
                            {
                              ref: "advanceSelectRef",
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "warehouseName",
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: {
                                change: _vm.nameChangeHandler,
                                "visible-change": _vm.onVisibleChange
                              },
                              model: {
                                value: _vm.backUpWarehouseInfo.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.backUpWarehouseInfo,
                                    "warehouseName",
                                    $$v
                                  )
                                },
                                expression: "backUpWarehouseInfo.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.WarehouseAddress") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "warehouseAddress",
                      type: "textarea",
                      rows: 5
                    },
                    model: {
                      value: _vm.backUpWarehouseInfo.warehouseAddress,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.backUpWarehouseInfo,
                          "warehouseAddress",
                          $$v
                        )
                      },
                      expression: "backUpWarehouseInfo.warehouseAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactWay") } },
                [
                  _vm.openWarehouse
                    ? _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { no: "warehouseContact" },
                        model: {
                          value: _vm.backUpWarehouseInfo.warehouseContact,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.backUpWarehouseInfo,
                              "warehouseContact",
                              $$v
                            )
                          },
                          expression: "backUpWarehouseInfo.warehouseContact"
                        }
                      })
                    : _vm._e(),
                  !_vm.openWarehouse
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "warehouseContact",
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            "allow-create": true,
                            clearable: true,
                            filterable: ""
                          },
                          on: {
                            change: _vm.contactsChangeHandler,
                            blur: _vm.selectContactBlur
                          },
                          model: {
                            value: _vm.backUpWarehouseInfo.warehouseContact,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.backUpWarehouseInfo,
                                "warehouseContact",
                                $$v
                              )
                            },
                            expression: "backUpWarehouseInfo.warehouseContact"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") } },
                [
                  _c("el-input", {
                    attrs: { no: "warehouseContactTel" },
                    model: {
                      value: _vm.backUpWarehouseInfo.warehouseContactTel,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.backUpWarehouseInfo,
                          "warehouseContactTel",
                          $$v
                        )
                      },
                      expression: "backUpWarehouseInfo.warehouseContactTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.CargosExpectedArrivalDate")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "arriveDate",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.backUpWarehouseInfo.arriveDate,
                      callback: function($$v) {
                        _vm.$set(_vm.backUpWarehouseInfo, "arriveDate", $$v)
                      },
                      expression: "backUpWarehouseInfo.arriveDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.LoadingRemarks") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { no: "remarks", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.backUpWarehouseInfo.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.backUpWarehouseInfo, "remarks", $$v)
                      },
                      expression: "backUpWarehouseInfo.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }